import * as React from 'react';
import PropTypes from 'prop-types';
import { theme } from '../../theme/theme';
import { ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import { DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { CANCEL, BOGLE_REGULAR, BOGLE_MEDIUM } from '../../constants/constant';

export default function AlertDialog(props) {
	const {
		title,
		description,
		alertCloseHandler,
		option,
		optionClickHandler,
	} = props;
	const [open, setOpen] = React.useState(true);

	const handleClose = () => {
		if (alertCloseHandler) {
			alertCloseHandler(false);
		} else {
			setOpen(false);
		}
	};

	function handleOnClick() {
		if (optionClickHandler) {
			optionClickHandler();
		} else {
			setOpen(false);
		}
	}

	return (
		<ThemeProvider theme={theme}>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				disableEnforceFocus
				aria-describedby="alert-dialog-description">
				<DialogTitle id="alert-dialog-title" sx={{ fontFamily: BOGLE_MEDIUM }}>
					{title}
				</DialogTitle>
				<DialogContent>
					<DialogContentText
						id="alert-dialog-description"
						sx={{ color: '#333333', fontFamily: BOGLE_REGULAR }}>
						{description}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose}>{CANCEL}</Button>
					<Button onClick={handleOnClick}>{option}</Button>
				</DialogActions>
			</Dialog>
		</ThemeProvider>
	);
}

AlertDialog.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	alertCloseHandler: PropTypes.func,
	option: PropTypes.string,
	optionClickHandler: PropTypes.func,
};
